import { pSBC } from '../../../utils';

const transformDataForPieWithPadding = (partotabla, nomenclator) => {
  const infoPartidos = partotabla.map(({ act }) => {
    const { codpar: codigoPartido, pvot: porcientoVotos, carg: cargos } = act;
    const partido = nomenclator.partidos[Number(codigoPartido) - 1];
    if(!partido) return {};
    const { nombre, color, codpar } = partido;
    return {
      nombre,
      color,
      cargos,
      codigoPartido: codpar.padStart(4, '0'),
      porcientoVotos: Number(porcientoVotos.slice(0, -1).replace(',', '.')).toFixed(2),
    };
  });
  const datosForPiePartidos = infoPartidos.map(
    ({ nombre = '', color, porcientoVotos, cargos, codigoPartido }, index) => {
      return {
        value: porcientoVotos,
        cargos,
        name: nombre,
        codigoPartido,
        itemStyle: {
          color,
        },
        emphasis: {
          itemStyle: {
            color: pSBC(-0.1, color),
          },
        },
      };
    }
  );
  return datosForPiePartidos;
};
export default transformDataForPieWithPadding;
